import React, { useState } from "react";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import "./Analyze.css";
import { toast } from "react-toastify";

const Analyze = () => {
  const [currentSection, setCurrentSection] = useState(3);

  const sections = [
    {
      id: 1,
      title: "Document Versioning & Execution Dates",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 2,
      title: "Statutory References & Alignment",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 3,
      title: "Reserve Fund Disclosures & Funding Requirements",
      isComplete: false,
      isCurrent: true,
    },
    {
      id: 4,
      title: "Election Procedures & Board Composition",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 5,
      title: "Budget & Financial Transparency",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 6,
      title: "Architectural Control Guidelines",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 7,
      title: "Leasing & Transfer Restrictions",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 8,
      title: "Enforcement & Fine Procedures",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 9,
      title: "Insurance Requirements & Risk Mitigation",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 10,
      title: "Safety Disclosures & Engineering Reports",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 11,
      title: "Member Access to Records",
      isComplete: true,
      isCurrent: false,
    },
    {
      id: 12,
      title: "Anti-Discrimination & Accessibility",
      isComplete: true,
      isCurrent: false,
    },
  ];

  const handleSectionClick = (id) => {
    const section = sections.find((s) => s.id === id);
    if (section.isComplete) {
      toast.info(`${section.title} is fully compliant, no review needed!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    setCurrentSection(id);
  };

  const currentSectionContent = () => {
    const section = sections.find((s) => s.id === currentSection);
    if (section?.isComplete) {
      return null;
    }

    if (currentSection === 3) {
      return <ReserveFundDisclosure />;
    }
    return (
      <div className="analyze-section-content">
        <h3>Section Content</h3>
        <p>This section's content would display here.</p>
      </div>
    );
  };

  return (
    <div className="analyze-document-checker">
      {/* Sidebar */}
      <div className="analyze-sidebar">
        {sections.map((section) => (
          <div
            key={section.id}
            onClick={() => handleSectionClick(section.id)}
            className={`analyze-section-item ${
              section.isCurrent
                ? "analyze-current"
                : section.isComplete
                ? "analyze-complete"
                : ""
            }`}
          >
            <div
              className={`analyze-section-icon ${
                section.isCurrent
                  ? "analyze-icon-current"
                  : section.isComplete
                  ? "analyze-icon-complete"
                  : "analyze-icon-default"
              }`}
            >
              {section.isComplete && !section.isCurrent ? (
                <CheckCircleRoundedIcon color="success" />
              ) : (
                <CancelRoundedIcon color="error" />
              )}
            </div>
            <span>{section.title}</span>
          </div>
        ))}
      </div>

      <div className="vr"></div>

      {/* Content */}
      <div className="analyze-content">{currentSectionContent()}</div>
    </div>
  );
};

const ReserveFundDisclosure = () => {
  return (
    <div className="analyze-reserve-section">
      <div className="analyze-header">
        <h2>Reserve Fund Disclosures & Funding Requirements</h2>
        <div className="analyze-status-badge">
          <div>
            <WarningRoundedIcon />
          </div>
          <div className="text-nowrap">Needs Review</div>
        </div>
      </div>

      <div className="analyze-card">
        <div>
          <h5>Statute:</h5>
          <p>Florida Statute 719.112 (2)</p>
          <h5>Document:</h5>
          <p>Bylaws, Section 6.2</p>
          <div className="analyze-alert-danger">
            Missing required statutory language about vote to waive reserves.
          </div>
          <div className="analyze-ai-suggestion">
            <span className="d-block text-danger-emphasis">
              AI-Suggested Draft Language:
            </span>
            The association may vote to waive the funding of reserves for
            capital expenditures and deferred maintenance by a majority of the
            voting interests present, in person or by proxy, at a duly called
            meeting.
          </div>
          <p>Statute Referenced: Florida Statute 720.303(6)(c)</p>
        </div>
        <p className="analyze-disclaimer">
          This language is provided for educational purposes only and is not
          legal advice. Please consult with your association attorney before
          making any changes to governing documents.
        </p>
        <button className="analyze-btn-outline">Add Comments</button>
      </div>
    </div>
  );
};

export default Analyze;
